module.exports = __webpack_public_path__ + "static/media/touch.06b7987e.png";